import { render, staticRenderFns } from "./ProductNavComponent.vue?vue&type=template&id=4533c764&scoped=true"
import script from "./ProductNavComponent.vue?vue&type=script&lang=js"
export * from "./ProductNavComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductNavComponent.vue?vue&type=style&index=0&id=4533c764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4533c764",
  null
  
)

export default component.exports